/** global google */
import { bboxPolygon, area } from 'turf'

const DEFAULT_SEARCH_RADIUS = 30000

const boundsToBbox = (bounds) => [
  bounds.getSouthWest().lng().toString(),
  bounds.getSouthWest().lat().toString(),
  bounds.getNorthEast().lng().toString(),
  bounds.getNorthEast().lat().toString(),
]

export const LatLngBoundsToArea = (bounds) => {
  const bbox = boundsToBbox(bounds)
  const poly = bboxPolygon(bbox)
  const areaFromPolygon = area(poly)
  const areaInSqkm = areaFromPolygon / 1e6

  return areaInSqkm
}

export const LocationToLatLngBounds = (
  center,
  radius = DEFAULT_SEARCH_RADIUS,
  Circle
) => {
  const bounds = new Circle({
    center,
    radius,
  }).getBounds()

  return bounds
}

export const getFiltersFromBounds = (bounds) => ({
  sw: bounds.getSouthWest().toUrlValue().split(','),
  ne: bounds.getNorthEast().toUrlValue().split(','),
})
